export default function Integrations() {
    return (
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center">
            <h1 className="mb-4">Integrations</h1>
            <p className="lead">
              Connect AKSEMA with your favorite tools to streamline workflows.
            </p>
            <div className="alert alert-info mt-4">
              <p className="mb-0">
                Integration support is under active development. Coming soon: Shopify, WooCommerce, QuickBooks, and more.
              </p>
            </div>
            <p className="mt-3">
              Have a specific tool in mind? let us know aksemainventory@gmail.com
            </p>
          </div>
        </div>
      </div>
    );
  }